export default "https://cdn-static.gokick.com/assets/fd6b0a6afc37e3a7e4b7ae7c7f4dd4a202138084/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";